import { Helmet } from "react-helmet-async";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { useEffect } from "react";

const HUBSPOT_V3_SCRIPT_ID = "hubspot-forms-v3-embed-25538277";
const HUBSPOT_V3_SCRIPT_SRC = "https://js-eu1.hsforms.net/forms/embed/25538277.js";

const ElectriseaInformation = () => {
  useEffect(() => {
    if (document.getElementById(HUBSPOT_V3_SCRIPT_ID)) return;
    const script = document.createElement("script");
    script.id = HUBSPOT_V3_SCRIPT_ID;
    script.src = HUBSPOT_V3_SCRIPT_SRC;
    script.defer = true;
    document.body.appendChild(script);
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <Helmet>
        <title>Electrisea Information | Cetasol</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <Header />
      <main className="pt-24 pb-20">
        <section className="bg-surface-light py-20">
          <div className="container mx-auto px-6">
            <div className="max-w-2xl mx-auto">
              <div
                className="hs-form-frame"
                data-region="eu1"
                data-form-id="736f576d-6a97-4014-9c3d-4efe3a6a0624"
                data-portal-id="25538277"
              />
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default ElectriseaInformation;
